var render = function render(){var _vm=this,_c=_vm._self._c;return (_vm.display)?_c('div',{staticClass:"section--saved-searches--box",attrs:{"title":_vm.display}},[_c('div',{staticClass:"name"},[_vm._v(_vm._s(_vm.value.display_name))]),_vm._v(" "),_c('span',[_vm._v(" : ")]),_vm._v(" "),_c('div',{staticClass:"values"},[_vm._v(_vm._s(_vm.display))])]):_vm._e()
}
var staticRenderFns = []

export { render, staticRenderFns }